export { default } from './CriticalError';
